import api from "../../../api/api";

const getAssociatedClinic = () =>{
    return new Promise((resolve, reject)=>{
        api.get("/associate/profile/clinic").then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}



const associatedClinicServices = {
    getAssociatedClinic,
    
}
export default associatedClinicServices;